/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.82"
        height="18.82"
        viewBox="0 0 18.82 18.82"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M.11 14.43v.13a3.51 3.51 0 0 0 1 3.24 3.38 3.38 0 0 0 2.41 1 3.94 3.94 0 0 0 .77-.08h.15l.1-.11 6.67-6.65 1.91 1.79.68-.73-1.88-1.77c4.12-4.11 5.87-5.86 6.46-6.55a.78.78 0 0 0 .2-.14 1.19 1.19 0 0 0 .17-1.32 5 5 0 0 0-1.29-1.83 3.66 3.66 0 0 0-2.42-1.4 1 1 0 0 0-.73.27 1.27 1.27 0 0 0-.13.19c-.72.6-2.43 2.32-6.91 6.82l-7 7.05ZM16.7 2.1a3.31 3.31 0 0 1 1.1 1.64 1.35 1.35 0 0 1-.67-.18l-.16-.1-.15-.1a6.12 6.12 0 0 1-.48-.41l-.1-.09a3.44 3.44 0 0 1-.27-.27c-.75-.84-1-1.37-.94-1.56.1-.03.66.06 1.67 1.07Zm-2.54-.36a2.4 2.4 0 0 0 .11.23 5.43 5.43 0 0 0 .84 1.17l.08.09a.12.12 0 0 1 .05.05l.07.08h.05a5 5 0 0 0 1.18.92l.12.06.26.13-6 6a3.69 3.69 0 0 1-2.88-2.9l6-6ZM1.02 14.93c1.5-1.52 3.91-3.94 6.31-6.35a4.73 4.73 0 0 0 2.91 2.87l-6.36 6.34a2.38 2.38 0 0 1-2.11-.69 2.54 2.54 0 0 1-.75-2.17Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'RolledScrollIcon';

export default Icon;
